$(document).ready(function () {
  let dpc = document.querySelector("delivery-promise-container");

  if (dpc && dpc.shadowRoot) {
    const observer = new MutationObserver((mutations, obs) => {
      const expiryLabel = dpc.shadowRoot.querySelector("#ddp-expiry-label");

      if (expiryLabel) {
        $(expiryLabel).css({
          "font-size": "16px",
        });
        obs.disconnect();
      }
    });

    observer.observe(dpc.shadowRoot, { childList: true, subtree: true });
  }
});
